/**
 * @fileoverview gRPC-Web generated client stub for fleet
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as shared_pb from './shared_pb';

import {
  AllStationsRequest,
  ClosestStationRequest,
  FavoriteDestinationsRequest,
  FilteredStationRequest,
  Station,
  StationRequest,
  StationResponseOrErrorResponse} from './station_pb';

export class StationServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetStations = new grpcWeb.AbstractClientBase.MethodInfo(
    StationResponseOrErrorResponse,
    (request: FilteredStationRequest) => {
      return request.serializeBinary();
    },
    StationResponseOrErrorResponse.deserializeBinary
  );

  getStations(
    request: FilteredStationRequest,
    metadata: grpcWeb.Metadata | null): Promise<StationResponseOrErrorResponse>;

  getStations(
    request: FilteredStationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void): grpcWeb.ClientReadableStream<StationResponseOrErrorResponse>;

  getStations(
    request: FilteredStationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/GetStations',
        request,
        metadata || {},
        this.methodInfoGetStations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/GetStations',
    request,
    metadata || {},
    this.methodInfoGetStations);
  }

  methodInfoGetDestinationsFromStation = new grpcWeb.AbstractClientBase.MethodInfo(
    StationResponseOrErrorResponse,
    (request: StationRequest) => {
      return request.serializeBinary();
    },
    StationResponseOrErrorResponse.deserializeBinary
  );

  getDestinationsFromStation(
    request: StationRequest,
    metadata: grpcWeb.Metadata | null): Promise<StationResponseOrErrorResponse>;

  getDestinationsFromStation(
    request: StationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void): grpcWeb.ClientReadableStream<StationResponseOrErrorResponse>;

  getDestinationsFromStation(
    request: StationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/GetDestinationsFromStation',
        request,
        metadata || {},
        this.methodInfoGetDestinationsFromStation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/GetDestinationsFromStation',
    request,
    metadata || {},
    this.methodInfoGetDestinationsFromStation);
  }

  methodInfoGetOriginsFromStation = new grpcWeb.AbstractClientBase.MethodInfo(
    StationResponseOrErrorResponse,
    (request: StationRequest) => {
      return request.serializeBinary();
    },
    StationResponseOrErrorResponse.deserializeBinary
  );

  getOriginsFromStation(
    request: StationRequest,
    metadata: grpcWeb.Metadata | null): Promise<StationResponseOrErrorResponse>;

  getOriginsFromStation(
    request: StationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void): grpcWeb.ClientReadableStream<StationResponseOrErrorResponse>;

  getOriginsFromStation(
    request: StationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/GetOriginsFromStation',
        request,
        metadata || {},
        this.methodInfoGetOriginsFromStation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/GetOriginsFromStation',
    request,
    metadata || {},
    this.methodInfoGetOriginsFromStation);
  }

  methodInfoGetAllStations = new grpcWeb.AbstractClientBase.MethodInfo(
    StationResponseOrErrorResponse,
    (request: AllStationsRequest) => {
      return request.serializeBinary();
    },
    StationResponseOrErrorResponse.deserializeBinary
  );

  getAllStations(
    request: AllStationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<StationResponseOrErrorResponse>;

  getAllStations(
    request: AllStationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void): grpcWeb.ClientReadableStream<StationResponseOrErrorResponse>;

  getAllStations(
    request: AllStationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/GetAllStations',
        request,
        metadata || {},
        this.methodInfoGetAllStations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/GetAllStations',
    request,
    metadata || {},
    this.methodInfoGetAllStations);
  }

  methodInfoGetFavoriteDestinations = new grpcWeb.AbstractClientBase.MethodInfo(
    StationResponseOrErrorResponse,
    (request: FavoriteDestinationsRequest) => {
      return request.serializeBinary();
    },
    StationResponseOrErrorResponse.deserializeBinary
  );

  getFavoriteDestinations(
    request: FavoriteDestinationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<StationResponseOrErrorResponse>;

  getFavoriteDestinations(
    request: FavoriteDestinationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void): grpcWeb.ClientReadableStream<StationResponseOrErrorResponse>;

  getFavoriteDestinations(
    request: FavoriteDestinationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/GetFavoriteDestinations',
        request,
        metadata || {},
        this.methodInfoGetFavoriteDestinations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/GetFavoriteDestinations',
    request,
    metadata || {},
    this.methodInfoGetFavoriteDestinations);
  }

  methodInfoGetClosestStation = new grpcWeb.AbstractClientBase.MethodInfo(
    StationResponseOrErrorResponse,
    (request: ClosestStationRequest) => {
      return request.serializeBinary();
    },
    StationResponseOrErrorResponse.deserializeBinary
  );

  getClosestStation(
    request: ClosestStationRequest,
    metadata: grpcWeb.Metadata | null): Promise<StationResponseOrErrorResponse>;

  getClosestStation(
    request: ClosestStationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void): grpcWeb.ClientReadableStream<StationResponseOrErrorResponse>;

  getClosestStation(
    request: ClosestStationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: StationResponseOrErrorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/GetClosestStation',
        request,
        metadata || {},
        this.methodInfoGetClosestStation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/GetClosestStation',
    request,
    metadata || {},
    this.methodInfoGetClosestStation);
  }

  methodInfoCreateStation = new grpcWeb.AbstractClientBase.MethodInfo(
    Station,
    (request: Station) => {
      return request.serializeBinary();
    },
    Station.deserializeBinary
  );

  createStation(
    request: Station,
    metadata: grpcWeb.Metadata | null): Promise<Station>;

  createStation(
    request: Station,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: Station) => void): grpcWeb.ClientReadableStream<Station>;

  createStation(
    request: Station,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: Station) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/CreateStation',
        request,
        metadata || {},
        this.methodInfoCreateStation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/CreateStation',
    request,
    metadata || {},
    this.methodInfoCreateStation);
  }

  methodInfoUpdateStation = new grpcWeb.AbstractClientBase.MethodInfo(
    Station,
    (request: Station) => {
      return request.serializeBinary();
    },
    Station.deserializeBinary
  );

  updateStation(
    request: Station,
    metadata: grpcWeb.Metadata | null): Promise<Station>;

  updateStation(
    request: Station,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: Station) => void): grpcWeb.ClientReadableStream<Station>;

  updateStation(
    request: Station,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: Station) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.StationService/UpdateStation',
        request,
        metadata || {},
        this.methodInfoUpdateStation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.StationService/UpdateStation',
    request,
    metadata || {},
    this.methodInfoUpdateStation);
  }

}

